"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InteractiveTourSk", {
    enumerable: true,
    get: function() {
        return InteractiveTourSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var _InteractiveTourSk;
let InteractiveTourSk = (_InteractiveTourSk = class InteractiveTourSk extends _lit.LitElement {
    updated(changedProperties) {
        if (changedProperties.has('active')) {
            if (this.active) {
                window.addEventListener('scroll', this._scrollListener, {
                    capture: true,
                    passive: true
                });
            } else {
                window.removeEventListener('scroll', this._scrollListener, {
                    capture: true
                });
            }
        }
        if (changedProperties.has('active') && this.active) {
            this._currentIndex = 0;
            this._updatePosition();
            this._dispatchStepChanged();
        }
        if (changedProperties.has('_currentIndex') && this.active) {
            this._updatePosition();
            this._dispatchStepChanged();
        }
    }
    _dispatchStepChanged() {
        this.dispatchEvent(new CustomEvent('step-changed', {
            detail: {
                index: this._currentIndex
            },
            bubbles: true,
            composed: true
        }));
    }
    _updatePosition(isRetry = false) {
        if (!this.active || this.steps.length === 0) return;
        const step = this.steps[this._currentIndex];
        // Probe document for targeted element
        const target = this._querySelectorDeep(step.selector);
        if (!target) {
            console.warn(`Tour target not found: ${step.selector}`);
            this._spotlightStyle = 'display: none;';
            this._bubbleStyle = 'top: 50%; left: 50%; transform: translate(-50%, -50%);';
            if (!isRetry) {
                setTimeout(()=>this._updatePosition(true), 200);
            }
            return;
        }
        const rect = target.getBoundingClientRect();
        // Position spotlight cutout
        this._spotlightStyle = `
      top: ${rect.top - 4}px;
      left: ${rect.left - 4}px;
      width: ${rect.width + 8}px;
      height: ${rect.height + 8}px;
    `;
        // Position bubble popup
        let bubbleTop = 0;
        let bubbleLeft = 0;
        const margin = 12;
        const bubbleWidth = 280;
        if (step.placement === 'bottom') {
            bubbleTop = rect.bottom + margin;
            bubbleLeft = rect.left + rect.width / 2 - bubbleWidth / 2;
        } else if (step.placement === 'top') {
            bubbleTop = rect.top - 160 - margin; // approximate bubble height
            bubbleLeft = rect.left + rect.width / 2 - bubbleWidth / 2;
        }
        // Bound checks to keep on screen
        const bubbleHeight = 180; // approximate height
        bubbleTop = Math.max(10, Math.min(window.innerHeight - bubbleHeight - 10, bubbleTop));
        bubbleLeft = Math.max(10, Math.min(window.innerWidth - bubbleWidth - 10, bubbleLeft));
        this._bubbleStyle = `top: ${bubbleTop}px; left: ${bubbleLeft}px;`;
    }
    _querySelectorDeep(selector, root = document) {
        const element = root.querySelector(selector);
        if (element) return element;
        const elements = root.querySelectorAll('*');
        for(let i = 0; i < elements.length; i++){
            const el = elements[i];
            if (el.shadowRoot) {
                const found = this._querySelectorDeep(selector, el.shadowRoot);
                if (found) return found;
            }
        }
        return null;
    }
    _onNext() {
        if (this._currentIndex < this.steps.length - 1) {
            this._currentIndex++;
        } else {
            this._onFinished();
        }
    }
    _onPrev() {
        if (this._currentIndex > 0) {
            this._currentIndex--;
        }
    }
    _onFinished() {
        this.active = false;
        this.dispatchEvent(new CustomEvent('tour-finished', {
            bubbles: true,
            composed: true
        }));
    }
    render() {
        if (!this.active || this.steps.length === 0) return (0, _lit.html)``;
        const step = this.steps[this._currentIndex];
        return (0, _lit.html)`
      <div class="tour-overlay">
        <div class="tour-spotlight" style=${this._spotlightStyle}></div>
        <div class="tour-bubble" style=${this._bubbleStyle}>
          <h4 class="bubble-title">${step.title}</h4>
          <p class="bubble-text">${step.text}</p>
          <div class="tour-footer">
            <button class="tour-btn tour-btn-skip" @click=${this._onFinished}>Skip</button>
            <span class="tour-progress">${this._currentIndex + 1}/${this.steps.length}</span>
            <div class="tour-nav-btns">
              ${this._currentIndex > 0 ? (0, _lit.html)`<button class="tour-btn" @click=${this._onPrev}>Back</button>` : ''}
              <button class="tour-btn tour-btn-primary" @click=${this._onNext}>
                ${this._currentIndex === this.steps.length - 1 ? 'Finish' : 'Next'}
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
    }
    constructor(...args){
        super(...args);
        this.active = false;
        this.steps = [];
        this._currentIndex = 0;
        this._bubbleStyle = '';
        this._spotlightStyle = '';
        this._scrollListener = ()=>this._updatePosition();
    }
}, (()=>{
    _InteractiveTourSk.styles = (0, _lit.css)`
    .tour-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 9999;
      pointer-events: none;
    }

    .tour-spotlight {
      position: fixed;
      box-shadow: 0 0 0 9999px color-mix(in srgb, var(--surface) 55%, transparent);
      border-radius: 8px;
      border: 2px solid var(--primary);
      transition: all 0.3s ease;
      pointer-events: none;
    }

    .tour-bubble {
      position: fixed;
      width: 280px;
      background: var(--surface);
      border: 1px solid var(--surface);
      border-radius: 8px;
      padding: 16px;
      box-shadow: 0 20px 25px -5px color-mix(in srgb, var(--transparent-overlay) 60%, transparent);
      color: var(--on-surface);
      z-index: 10000;
      transition: all 0.3s ease;
      display: flex;
      flex-direction: column;
      gap: 8px;
      pointer-events: auto;
    }

    .bubble-title {
      font-weight: 700;
      color: var(--primary);
      font-size: 14px;
      margin: 0;
    }

    .bubble-text {
      font-size: 12px;
      line-height: 1.5;
      margin: 0;
      color: var(--on-surface-variant);
    }

    .tour-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      font-size: 11px;
    }

    .tour-nav-btns {
      display: flex;
      gap: 6px;
    }

    .tour-btn {
      background: none;
      border: none;
      color: var(--on-surface-variant);
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 4px;
      font-weight: 600;
    }

    .tour-btn:hover {
      background: color-mix(in srgb, var(--on-surface) 5%, transparent);
      color: var(--on-surface);
    }

    .tour-btn-primary {
      background: var(--primary);
      color: var(--on-primary);
    }

    .tour-btn-primary:hover {
      background: var(--primary-variant);
      color: var(--on-primary);
    }

    .tour-progress {
      color: var(--on-surface-variant);
      font-weight: 500;
    }
  `;
})(), _InteractiveTourSk);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    })
], InteractiveTourSk.prototype, "active", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Array
    }),
    _ts_metadata("design:type", Array)
], InteractiveTourSk.prototype, "steps", void 0);
_ts_decorate([
    (0, _decorators.state)()
], InteractiveTourSk.prototype, "_currentIndex", void 0);
_ts_decorate([
    (0, _decorators.state)()
], InteractiveTourSk.prototype, "_bubbleStyle", void 0);
_ts_decorate([
    (0, _decorators.state)()
], InteractiveTourSk.prototype, "_spotlightStyle", void 0);
InteractiveTourSk = _ts_decorate([
    (0, _decorators.customElement)('interactive-tour-sk')
], InteractiveTourSk);
